import { Mask, type MaskType } from 'maska'

export const capitalize = (value: string) => value.charAt(0).toUpperCase() + value.slice(1)

export const mask = (mask: MaskType, value?: string) =>
  mask && value ? new Mask({ mask }).masked(value) : ''

export const normalizeKey = (key: string) => key.toLowerCase().replace(/[^0-9a-z.]/gi, '')

export const pad = (value?: number) => {
  if (typeof value !== 'number') return ''
  if (value <= 0) return '00'
  if (value < 10) return `0${value}`
  return `${value}`
}

export const splitCamelCase = (value: string) =>
  value
    .replace(/([A-Z])/g, (match) => ` ${match}`)
    .replace(/^./, (match) => match.toUpperCase())
    .trim()

export const toPascalCase = (value: string) =>
  value
    .toLowerCase()
    .replace(/[-_]+/g, ' ')
    .replace(/[^\w\s]/g, '')
    .replace(/\s+(.)(\w*)/g, (_, l1, l2) => `${l1.toUpperCase()}${l2}`)
    .replace(/\w/, (s) => s.toUpperCase())

export const toSnakeCase = (value: string) =>
  value
    .replace(/ /g, '_')
    .replace(/([a-z])([A-Z])/g, '$1_$2')
    .replace(/([A-Z])([A-Z][a-z])/g, '$1_$2')
    .toLowerCase()

export const maskEmail = (email: string) => {
  const [local, domain] = email.split('@')
  const maskPart = (s: string) =>
    s.length <= 2 ? s[0] + '*' : s[0] + '*'.repeat(s.length - 2) + s[s.length - 1]
  return `${maskPart(local)}@${maskPart(domain)}`
}

export const truncate = (value: string, length: number) =>
  value.length > length ? value.slice(0, length) : value
